if (!customElements.get('product-carousel-infinite')) {
  customElements.define('product-carousel-infinite', class extends HTMLElement {
    #observer = null;

    connectedCallback() {
      if (this.#observer) return;

      this.#observer = new IntersectionObserver((entries, observer) => {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          this.#initSwiper();
        }
      });

      this.#observer.observe(this);
    }

    async #initSwiper() {
      await window.Theme.loadSwiper();
      new Swiper(this.querySelector("[data-product-carousel-infinite-swiper]"), {
        loop: true,
        slidesPerView: "auto",
        loopAdditionalSlides: 4,
        mousewheel: {
          forceToAxis: true
        }
      });
    }
  })
}